import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SignUpStatus, TranslationContext } from "@is/constants";

type Props = {
  status: SignUpStatus;
  errorMessage: string | null;
};

const useManageSignUpStatusModal = ({ status, errorMessage }: Props) => {
  const { t } = useTranslation(TranslationContext.General);

  const title = useMemo(
    () =>
      status === SignUpStatus.AccountCreated
        ? t("You're all signed up!")
        : t("Something went wrong"),
    [status, t]
  );

  const failedStatusText = useMemo(
    () => (errorMessage ? errorMessage : t("Please try again")),
    [errorMessage, t]
  );

  return {
    title,
    failedStatusText,
    t,
  };
};

export default useManageSignUpStatusModal;
